import styled from '@emotion/styled';
import type { Prismic } from '@landsbankinn/prismic';
import { Modal, PlayButton } from '@landsbankinn/ui';
import React, { useState } from 'react';
import { Img } from '../../components/img/Img';
import { BoxClose } from '../icons/BoxClose';

const Host = styled.div`
  position: relative;
`;

const Video = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
`;

const Play = styled.button`
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: rgba(255, 255, 255, 0);
  transition: color ease-in-out 110ms;
  width: 100%;
  &:hover {
    color: rgba(255, 255, 255, 1);
  }
`;

const Span = styled.span`
  position: absolute;
  top: -60px;
  right: 0;
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  svg {
    margin-left: 23px;
  }
`;

const Div = styled.div`
  width: 100%;
  height: 0px;
  padding-top: 56.25%;
  position: relative;
`;

interface ImageVideoProps {
  image: any;
  video: Prismic.Embed;
  [key: string]: any;
}

// Image with video play button that plays video
export function ImageVideo(props: ImageVideoProps) {
  const { image, video, ar, ...rest } = props;
  const fullWidthHeightHtml = (video?.html || '')
    .replace(/width="\d+"/, 'width="100%"')
    .replace(/height="\d+"/, 'height="100%"')
    .replace(/src="(.*?)"/, (value, url) => {
      return `src="${url}${url.indexOf('?') === -1 ? '?' : '&'}autoplay=1"`;
    });
  const [play, setPlay] = useState(false);
  const onPlayClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setPlay(true);
    return false;
  };
  return (
    <Host>
      <Img src={image} ar={ar} {...rest} />
      {play && (
        <Modal visible={play} onClose={() => setPlay(false)}>
          <Div>
            <Span onClick={() => setPlay(false)}>
              <span>Loka glugga</span>
              <BoxClose />
            </Span>
            <Video dangerouslySetInnerHTML={{ __html: fullWidthHeightHtml }} />
          </Div>
        </Modal>
      )}
      {!play && (
        <Play onClick={onPlayClick}>
          <PlayButton />
        </Play>
      )}
    </Host>
  );
}
